module.exports = __webpack_public_path__ + "static/media/magic-portal-blue.1780c758.svg";